module.exports = __webpack_public_path__ + "static/2-001-1732043c8b4be12e5ff5931cc62aca50.jpg";